import React from "react";

export default function ContactSection() {
  return (
    <section className="py-20 bg-section border-t border-secondary/20">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div className="flex flex-col gap-6">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-2 tracking-tight">Kapcsolat</h2>
          <div className="text-gray-300 text-lg">
            <div className="mb-2">
              <span className="font-bold text-white">Cím:</span> <span className="text-secondary">Dabas</span>
            </div>
            <div className="mb-2">
              <span className="font-bold text-white">Telefon:</span> <a href="tel:+36304130001" className="text-secondary hover:text-hover hover:underline" aria-label="Telefon: +36 30 413 0001" tabIndex={0}>+36 30 413 0001</a>
            </div>
            <div className="mb-2">
              <span className="font-bold text-white">Email:</span> <a href="mailto:hoppxplatform@gmail.com" className="text-secondary hover:text-hover hover:underline" aria-label="Email: hoppxplatform@gmail.com" tabIndex={0}>hoppxplatform@gmail.com</a>
            </div>
            <div className="flex gap-4 mt-4">
              <a href="https://facebook.com/hopphomes" target="_blank" rel="noopener noreferrer" aria-label="Facebook" tabIndex={0}><svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M17 2.1H7A4.9 4.9 0 0 0 2.1 7v10A4.9 4.9 0 0 0 7 21.9h5V15h-2v-2h2v-1.5A3.5 3.5 0 0 1 15.5 8H18v2h-2.5a1.5 1.5 0 0 0-1.5 1.5V13h3l-.5 2h-2.5v6.9h2A4.9 4.9 0 0 0 21.9 17V7A4.9 4.9 0 0 0 17 2.1Z" fill="#e31937"/></svg></a>
              <a href="https://instagram.com/hopphomes" target="_blank" rel="noopener noreferrer" aria-label="Instagram" tabIndex={0}><svg width="32" height="32" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="5" stroke="#e31937" strokeWidth="2"/><rect x="2" y="2" width="20" height="20" rx="6" stroke="#e31937" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1.5" fill="#e31937"/></svg></a>
              <a href="https://tiktok.com/@hopphomes" target="_blank" rel="noopener noreferrer" aria-label="TikTok" tabIndex={0}><svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M17 3v8.38a4.62 4.62 0 1 1-4.62-4.62" stroke="#e31937" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12.38" cy="15.62" r="4.62" fill="#e31937" opacity=".12"/></svg></a>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center w-full h-72 md:h-96">
          <div className="flex gap-12 md:gap-20 justify-center items-center">
            <a href="https://facebook.com/hopphomes" target="_blank" rel="noopener noreferrer" aria-label="Facebook" tabIndex={0}>
              <svg width="64" height="64" fill="none" viewBox="0 0 24 24">
                <path d="M17 2.1H7A4.9 4.9 0 0 0 2.1 7v10A4.9 4.9 0 0 0 7 21.9h5V15h-2v-2h2v-1.5A3.5 3.5 0 0 1 15.5 8H18v2h-2.5a1.5 1.5 0 0 0-1.5 1.5V13h3l-.5 2h-2.5v6.9h2A4.9 4.9 0 0 0 21.9 17V7A4.9 4.9 0 0 0 17 2.1Z" fill="#e31937"/>
              </svg>
            </a>
            <a href="https://instagram.com/hopphomes" target="_blank" rel="noopener noreferrer" aria-label="Instagram" tabIndex={0}>
              <svg width="64" height="64" fill="none" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="5" stroke="#e31937" strokeWidth="2"/>
                <rect x="2" y="2" width="20" height="20" rx="6" stroke="#e31937" strokeWidth="2"/>
                <circle cx="17.5" cy="6.5" r="1.5" fill="#e31937"/>
              </svg>
            </a>
            <a href="https://tiktok.com/@hopphomes" target="_blank" rel="noopener noreferrer" aria-label="TikTok" tabIndex={0}>
              <svg width="64" height="64" fill="none" viewBox="0 0 24 24">
                <path d="M17 3v8.38a4.62 4.62 0 1 1-4.62-4.62" stroke="#e31937" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="12.38" cy="15.62" r="4.62" fill="#e31937" opacity=".12"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
